import styled from "styled-components";
import { connect } from "react-redux";
import React, {useState} from 'react';

import { getInterests, getInterestedProfiles } from "../../store/actions";

import AdvancedSearch from '../AdvancedSearch';
import PhotoUpload from '../Shared/PhotoUpload';

const Container = styled.div`
  max-width: 760px;
`;

const Title = styled.h1`
  font-size: clamp(30px, 4vw, 42px);
  letter-spacing: -0.03em;
  margin-bottom: 8px;
`;

const Sub = styled.p`
  color: var(--text-muted);
  font-size: 17px;
  margin-bottom: 32px;
`;

const Upload = styled.div`
  padding: clamp(20px, 3vw, 32px);
  border-radius: var(--radius-card);
  background: var(--surface);
  border: 1.5px dashed var(--border-strong);

  h2 {
    font-size: 20px;
    margin-bottom: 4px;
  }

  p {
    color: var(--text-muted);
    margin: 0;
  }
`;

const MyAccount = (props) => {
    const [isInterestFetched, setIsInterestFetched] = useState(false);
    const [isInterestProfileFetched, setIsInterestProfileFetched] = useState(false);
    if(props.profileInterests && !isInterestProfileFetched) {
        setIsInterestProfileFetched(true);
        const interests = props.profileInterests.interests;
        const interestedProfileIds = interests.reduce(function (result, item) {
            result.push(item.senderUid);
            return result;
        }, []);
        props.getInterestedProfiles(interestedProfileIds);
    } else if(!props.profileInterests && !isInterestFetched) {
        setIsInterestFetched(true);
        props.getInterests(props.user.uid);
    }
    const isProfilePicSet = props.profile.profile_pic ? true : false;
    return (
        <Container>
            <Title>Welcome to Vinayaka Matrimony</Title>
            <Sub>Use the menu to view your profile, add photos and search for matches.</Sub>
            {!isProfilePicSet && 
              <Upload>
                <h2>Add a profile picture</h2>
                <p>Please upload and set a profile picture for better reach.</p>
                <PhotoUpload props={ props } />
              </Upload>
            }
        </Container>
    );
};

const mapStateToProps = (state) => {
  return {
    user: state.userState.user,
    profile: state.profileState.profile,
    profileInterests: state.profileState.profileInterests
  };
};

const mapDipatchToProps = (dispatch) => ({
  getInterests: (uid) => dispatch(getInterests(uid)),
  getInterestedProfiles: (uids) => dispatch(getInterestedProfiles(uids)),
});


export default connect(mapStateToProps, mapDipatchToProps)(MyAccount);
